export default [
  {
    path: '/statistics',
    name: 'statistics',
    component: () => import('./_views/statistics'),
    meta: {
      title: 'Statistics',
      navigation: {
        position: 2,
        exact: true,
        name: 'Statistics',
        icon: 'bar_chart',
        specialQueries: ['suffix'],
        to: {
          name: 'statistics',
          query: {
            suffix: '',
          },
        },
      },
    },
  },
];
